import { useSyncExternalStore } from 'react';

/**
 * navigator.onLine is a cheap pre-check: false means definitely offline
 * (skip the request and queue immediately); true only means "maybe" — the
 * NetworkError path catches the cases the browser gets wrong.
 */
export function isOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

function subscribe(callback: () => void): () => void {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

/** Reactive online/offline flag for components (RealtimeStatusPill). */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
